import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('api-ui-fota-management.Constants');
export default {
  get device() {
    return t('Names.device');
  },
  get deviceGroup() {
    return t('Names.deviceGroup');
  },
  get deviceType() {
    return t('Names.deviceType');
  },
  get firmwareRelease() {
    return t('Names.firmwareRelease');
  },
  get firmwareApplication() {
    return t('Names.firmwareApplication');
  },
  get firmwareComponent() {
    return t('Names.firmwareComponent');
  },
  get devicePlural() {
    return t('NamesPlural.device');
  },
  get deviceGroupPlural() {
    return t('NamesPlural.deviceGroup');
  },
  get deviceTypePlural() {
    return t('NamesPlural.deviceType');
  },
  get firmwareReleasePlural() {
    return t('NamesPlural.firmwareRelease');
  },
  get firmwareApplicationPlural() {
    return t('NamesPlural.firmwareApplication');
  },
  get firmwareComponentPlural() {
    return t('NamesPlural.firmwareComponent');
  },
  get 'leverege.fotaApi.device'() {
    return t('Names.device');
  },
  get 'leverege.fotaApi.deviceGroup'() {
    return t('Names.deviceGroup');
  },
  get 'leverege.fotaApi.deviceType'() {
    return t('Names.deviceType');
  },
  get 'leverege.fotaApi.firmwareRelease'() {
    return t('Names.firmwareRelease');
  },
  get 'leverege.fotaApi.firmwareApplication'() {
    return t('Names.firmwareApplication');
  },
  get 'leverege.fotaApi.firmwareComponent'() {
    return t('Names.firmwareComponent');
  },
  get 'leverege.fotaApi.devicePlural'() {
    return t('NamesPlural.device');
  },
  get 'leverege.fotaApi.deviceGroupPlural'() {
    return t('NamesPlural.deviceGroup');
  },
  get 'leverege.fotaApi.deviceTypePlural'() {
    return t('NamesPlural.deviceType');
  },
  get 'leverege.fotaApi.firmwareReleasePlural'() {
    return t('NamesPlural.firmwareRelease');
  },
  get 'leverege.fotaApi.firmwareApplicationPlural'() {
    return t('NamesPlural.firmwareApplication');
  },
  get 'leverege.fotaApi.firmwareComponentPlural'() {
    return t('NamesPlural.firmwareComponent');
  }
};